<template>
  <div
    class="user-image"
    :style="{
      width: props.width + 'px',
      height: props.height + 'px',
      background: background,
    }"
  >
    <img v-if="props.src" :src="props.src" :alt="props.alt" ref="imageProfile" />
    <template v-else>
      {{
        UserService.getUserInitials({
          firstName: props.user?.firstName,
          lastName: props.user?.lastName,
        })
      }}
    </template>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import UserService from "@/services/user.service";
import blackPerson from '@/assets/images/blank_person.jpg';

const props = defineProps({
  src: { type: String, default: "" },
  user: { type: Object, default: null },
  alt: { type: String, default: "" },
  width: { type: [Number, String], default: 60 },
  height: { type: [Number, String], default: 60 },
  background: { type: String, default: "#529096" },
}),
    imageProfile = ref();
// if (
//   props.user !== null &&
//   !props.src &&
//   !props.user.firstName &&
//   !props.user.lastName
// ) {
//   throw new Error(
//     "User prop in UserImage requires firstName and lastName fields if the src is not present"
//   );
// }

onMounted(() => {
    imageProfile.value?.addEventListener('error', (event) => {
        event.target.src = blackPerson;
        event.onerror = null
    })
})

const background = computed(() => {
  if (props.src) {
    return "transparent";
  }
  if (props.user.firstName && props.user.lastName) {
    return props.background;
  }
  return "transparent";
});
</script>

<style lang="scss">
.user-image {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 1.75rem;
  line-height: 1.2;
  letter-spacing: 0.025em;

  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
    border-radius: 50%;
  }
}
</style>
